import { Typography, Stack, Box, Button, Divider, Grid, Select, InputLabel, IconButton, TextField, MenuItem, Checkbox, Modal, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ReactComponent as ChecklistFormIcon } from "../../../../Icons/Account/ChecklistForm.svg"
import { ReactComponent as SandClockIcon } from "../../../../Icons/Account/SandClock.svg"
import { ReactComponent as PuzzlePiecesIcon } from "../../../../Icons/Account/PuzzlePieces.svg"
import { ReactComponent as TickIcon } from "../../../../Icons/Account/TickIcon.svg"
import { ReactComponent as ApprovedIcon } from "../../../../Icons/Account/ApprovedIcon.svg"
import { ReactComponent as RightArrowIcon } from "../../../../Icons/rightArrow.svg"
import { ReactComponent as DownloadIcon } from "../../../../Icons/Account/Download.svg"
import { ReactComponent as ShareIcon } from "../../../../Icons/ShareIcon.svg"
import { ReactComponent as RejectedIcon } from "../../../../Icons/Account/RejectedIcon.svg"
import axiosInstance from '../../../../api/axiosInstance'
import DeleteIcon from "@mui/icons-material/Delete";
import { useSelector } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'



export default function Checklist() {
    
    const [showScreen, setShowScreen] = useState({
        screen1 : true, //initial
        screen2 : false, //apply
        screen3 : false, //pending
        screen4 : false, //completed
        screen5 : false, //resubmit
    })

    const [checkListProducts, setCheckListProducts] = useState([])
    const language = useSelector((state) => state.language.language)
    const [signature, setSignature] = useState(null);
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState({});
    const user = useSelector((state) => state.AdminData.admin);
    const [appliedData, setAppliedData] = useState({})
    const [canSelectFields, setSelectFields] = useState(true)
    const [isAgree, setIsAgree] = useState(false);
    
    const handleAgreeChange = (event) => {
      setIsAgree(event.target.checked);
    };

    const handleScreen = (screen) => {
        setShowScreen((prev) => {
            const updatedScreens = Object.keys(prev).reduce((acc, key) => {
            acc[key] = key === screen;
            return acc;
            }, {});
            
            return updatedScreens;
        });
        };

        const handleCheckboxChange = (id, type) => {
          setSelected((prev) => {
            const updated = { ...prev };

            if (updated[id] === type) {
              delete updated[id]; // uncheck
            } else {
              updated[id] = type; // check
            }

            return updated;
          });
        };


    const fetchCheckListProducts = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-check-list-all`)
            console.log(response)
            if(response.status == 200){
                setCheckListProducts(response.data.data)
            }
        } catch (error) {
            console.log(error)
        }
}

const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSignature(file);
    }
  };

  const handleRemove = () => {
    setSignature(null);
  };


  const getCheckList = async (studentId) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}checklist/${studentId}`
    );

    console.log(response.data);
    setAppliedData(response.data.data[0])
  } catch (error) {
    console.log(error);
  }
};

useEffect(() => {
    if(user?.id){
      getCheckList(user?.id)
    }
}, [user])

useEffect(() => {
  if(appliedData?._id){
      if(appliedData?.status === "pending" || appliedData?.status === "resubmit"){
        handleScreen('screen3')
        setSelectFields(false)
      }
      if(appliedData?.status === "completed"){
        handleScreen('screen4')
        setSelectFields(false)
      }
      if(appliedData?.status === "failed"){
        handleScreen('screen5')
        setSelectFields(true)
      }

      setSelected(appliedData?.selectedProducts)
  }
}, [appliedData])

useEffect(() => {
    fetchCheckListProducts()
}, [])

console.log(selected)

const handleSubmit = async () => {
  try {

    if (!selected || Object.keys(selected).length === 0) {
      toast.error("Please select the products")
      return;
    }

    if (!signature) {
      toast.error("Please upload your signature");
      return;
    }

    const formData = new FormData();


    formData.append("selectedProducts", JSON.stringify(selected));
    formData.append("student_id", user.id); // make sure studentId exists
    formData.append("signature", signature); // file object

    const response = await axiosInstance.post(
      `${process.env.REACT_APP_API_URL}apply-checklist`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(response.data);
    if(response.status == 201){
      getCheckList(user.id)
    }
  } catch (error) {
    console.log(error);

  }
};


const handleReSubmit = async () => {
  try {

    if (!selected || Object.keys(selected).length === 0) {
      alert("Please select at least one product");
      return;
    }

    const formData = new FormData();


    formData.append("selectedProducts", JSON.stringify(selected));
    formData.append("student_id", user.id); // make sure studentId exists
    formData.append("status", "resubmit"); // file object

    const response = await axiosInstance.put(
      `${process.env.REACT_APP_API_URL}checklist/update`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log(response.data);
    if(response.status == 200){
      getCheckList(user.id)
    }
  } catch (error) {
    console.log(error);

  }
};


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60dvw",
  height : "75dvh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  overflowY : 'scroll'
};

const tableHeader = {color : '#737373', fontWeight : 700}
const tableText = {color : '#1A2461', fontWeight : 700}

    return (
        <>
        <ToastContainer />
        {showScreen?.screen1 && (
            <>
            <Box>
            <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                <Typography variant="h7_1">Furniture & Equipment Checklist</Typography>
            </Stack>
            <Divider />
            <Stack mt={2} direction="column" gap="20px" sx={{ border: ".5px solid #737373", borderRadius: "8px", padding: {xs : '10px 10px', lg : "20px 30px"} }}>
                <Stack direction={{xs : 'row', lg:'row'}} justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" gap={{xs : '30px', lg: '20px'}}>
                        <ChecklistFormIcon />
                        <Box>
                            <Typography variant="h7_1">Checklist</Typography><br />
                            <Typography variant="h9_5">Furniture & Equipment checklist</Typography>
                            

                            {/* <Stack mt={1} direction="row" justifyContent="center" alignItems="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #52AD33", backgroundColor: "#eef7eb", borderRadius: "30px", padding: "10px", color: "#52AD33" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Done</Typography>
                                <ApprovedIcon />
                            </Stack> */}
                        </Box>
                    </Stack>
                    <Button onClick={() => handleScreen("screen2")} endIcon={<RightArrowIcon />} variant='contained' sx={{ fontSize: "16px", fontWeight: 700 }}>Complete now</Button>
                </Stack>
            </Stack>
            
        </Box>
            </>
        )}



        {showScreen?.screen2 && (
        <Box>
            <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                <Typography variant="h7_1">Furniture & Equipment Checklist</Typography>
            </Stack>
            <Divider />
            <Stack mt={2} direction="column" gap="20px" sx={{ border: ".5px solid #737373", borderRadius: "8px", padding: {xs : '10px 10px', lg : "20px 30px"} }}>
                <Stack direction={{xs : 'row', lg:'row'}} justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" gap={{xs : '30px', lg: '20px'}}>
                        <ChecklistFormIcon />
                        <Box>
                            <Typography variant="h7_1">Checklist</Typography><br />
                            <Typography variant="h9_5">Furniture & Equipment checklist</Typography>
                            {/* <Stack mt={1} direction="row" alignItems="center" justifyContent="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #C38236", backgroundColor: "#f9f3eb", borderRadius: "30px", padding: "10px", color: "#C38236" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Pending</Typography>
                                <SandClockIcon style={{ width: "10px", height: "13px" }} />
                            </Stack> */}

                            {/* <Stack mt={1} direction="row" justifyContent="center" alignItems="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #52AD33", backgroundColor: "#eef7eb", borderRadius: "30px", padding: "10px", color: "#52AD33" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Done</Typography>
                                <ApprovedIcon />
                            </Stack> */}
                        </Box>
                    </Stack>
                    <Button onClick={() => setOpen(true)} variant='contained' sx={{ fontSize: "16px", fontWeight: 700 }}>Select Products</Button>
                </Stack>
            </Stack>
            <Stack mt={3} direction="column">
                <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                    <Typography variant="h7_1">Terms & Conditions</Typography>
                </Stack>
                <Divider />
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', mt: 2, ml: 4 }} variant="h7_2">No wall pasting of any material is allowed in the room and toilet of the hostel. The cost of repainting of the damaged wall will be borne by the student. </Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2"> Dining in room is strictly prohibited, avoid using high voltage equipment such as kettle, iron, rice-cooker etc. Violator will be fined $50 each time. For dining, please use the multi-functional hall on first floor. Please keep the room clean &tidy.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">According to Singapore regulation, smoking is prohibited within the hostel premises. Violator will be fined $300 each time.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">All furniture & equipment is in good working condition. In case of damage due to improper use, the original price listed in the check-list will be charged to the tenant </Typography>
            </Stack>

            <Box>
      <Typography variant="subtitle1" sx={{fontWeight : 700}} mt={4} mb={1}>
        Upload Signature
      </Typography>

      {!signature ? (
        <Button
          variant="outlined"
          component="label"
          sx={{
            height: 120,
            width: 300,
            borderStyle: "dashed",
          }}
        >
          Click to Upload
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </Button>
      ) : (
        <Box
          sx={{
            position: "relative",
            width: 300,
            height: 120,
            border: "1px solid #ddd",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <img
            src={URL.createObjectURL(signature)}
            alt="Signature Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />

          <IconButton
            size="small"
            onClick={handleRemove}
            sx={{
              position: "absolute",
              top: 5,
              right: 5,
              backgroundColor: "white",
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      )}

    </Box>

            <Stack mt={2} gap="10px" direction="row" alignItems="center" justifyContent="start" >
                <Checkbox
                  checked={isAgree}
                  onChange={handleAgreeChange}
                />
                <Typography variant='h9_1' color="text_blue">I agree all the provided Information are correct</Typography>
            </Stack>
            <Stack my={3} direction="row" alignItems="center" justifyContent="start">
                <Button sx={{
    "&.Mui-disabled": {
      backgroundColor: "#E0E0E0",
      color: "#9E9E9E",
      cursor: "not-allowed",
    },
  }} disabled={!isAgree} onClick={() => handleSubmit()} variant="standard">Complete</Button>
            </Stack>
        </Box>
         )}


         {showScreen?.screen3 && (
        <Box>
            <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                <Typography variant="h7_1">Furniture & Equipment Checklist</Typography>
            </Stack>
            <Divider />
            <Stack mt={2} direction="column" gap="20px" sx={{ border: ".5px solid #737373", borderRadius: "8px", padding: {xs : '10px 10px', lg : "20px 30px"} }}>
                <Stack direction={{xs : 'row', lg:'row'}} justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" gap={{xs : '30px', lg: '20px'}}>
                        <ChecklistFormIcon />
                        <Box>
                            <Typography variant="h7_1">Checklist</Typography><br />
                            <Typography variant="h9_5">Furniture & Equipment checklist</Typography>
                            <Stack mt={1} direction="row" alignItems="center" justifyContent="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #C38236", backgroundColor: "#f9f3eb", borderRadius: "30px", padding: "10px", color: "#C38236" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Pending</Typography>
                                <SandClockIcon style={{ width: "10px", height: "13px" }} />
                            </Stack>

                            {/* <Stack mt={1} direction="row" justifyContent="center" alignItems="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #52AD33", backgroundColor: "#eef7eb", borderRadius: "30px", padding: "10px", color: "#52AD33" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Done</Typography>
                                <ApprovedIcon />
                            </Stack> */}
                        </Box>
                    </Stack>
                    <Button onClick={() => setOpen(true)} variant='contained' sx={{ fontSize: "16px", fontWeight: 700 }}>View Selected Products</Button>
                </Stack>
            </Stack>
            <Stack mt={3} direction="column">
                <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                    <Typography variant="h7_1">Terms & Conditions</Typography>
                </Stack>
                <Divider />
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', mt: 2, ml: 4 }} variant="h7_2">No wall pasting of any material is allowed in the room and toilet of the hostel. The cost of repainting of the damaged wall will be borne by the student. </Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2"> Dining in room is strictly prohibited, avoid using high voltage equipment such as kettle, iron, rice-cooker etc. Violator will be fined $50 each time. For dining, please use the multi-functional hall on first floor. Please keep the room clean &tidy.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">According to Singapore regulation, smoking is prohibited within the hostel premises. Violator will be fined $300 each time.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">All furniture & equipment is in good working condition. In case of damage due to improper use, the original price listed in the check-list will be charged to the tenant </Typography>
            </Stack>

        </Box>
         )}

         {showScreen?.screen4 && (
        <Box>
            <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                <Typography variant="h7_1">Furniture & Equipment Checklist</Typography>
            </Stack>
            <Divider />
            <Stack mt={2} direction="column" gap="20px" sx={{ border: ".5px solid #737373", borderRadius: "8px", padding: {xs : '10px 10px', lg : "20px 30px"} }}>
                <Stack direction={{xs : 'row', lg:'row'}} justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" gap={{xs : '30px', lg: '20px'}}>
                        <ChecklistFormIcon />
                        <Box>
                            <Typography variant="h7_1">Checklist</Typography><br />
                            <Typography variant="h9_5">Furniture & Equipment checklist</Typography>
                            {/* <Stack mt={1} direction="row" alignItems="center" justifyContent="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #C38236", backgroundColor: "#f9f3eb", borderRadius: "30px", padding: "10px", color: "#C38236" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Pending</Typography>
                                <SandClockIcon style={{ width: "10px", height: "13px" }} />
                            </Stack> */}

                            <Stack mt={1} direction="row" justifyContent="center" alignItems="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #52AD33", backgroundColor: "#eef7eb", borderRadius: "30px", padding: "10px", color: "#52AD33" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Done</Typography>
                                <ApprovedIcon />
                            </Stack>
                        </Box>
                    </Stack>
                    <Button onClick={() => setOpen(true)} variant='contained' sx={{ fontSize: "16px", fontWeight: 700 }}>View Selected Products</Button>
                </Stack>
            </Stack>
            <Stack mt={3} direction="column">
                <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                    <Typography variant="h7_1">Terms & Conditions</Typography>
                </Stack>
                <Divider />
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', mt: 2, ml: 4 }} variant="h7_2">No wall pasting of any material is allowed in the room and toilet of the hostel. The cost of repainting of the damaged wall will be borne by the student. </Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2"> Dining in room is strictly prohibited, avoid using high voltage equipment such as kettle, iron, rice-cooker etc. Violator will be fined $50 each time. For dining, please use the multi-functional hall on first floor. Please keep the room clean &tidy.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">According to Singapore regulation, smoking is prohibited within the hostel premises. Violator will be fined $300 each time.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">All furniture & equipment is in good working condition. In case of damage due to improper use, the original price listed in the check-list will be charged to the tenant </Typography>
            </Stack>

        </Box>
         )}

         {showScreen?.screen5 && (
        <Box>
            <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                <Typography variant="h7_1">Furniture & Equipment Checklist</Typography>
            </Stack>
            <Divider />
            <Stack mt={2} direction="column" gap="20px" sx={{ border: ".5px solid #737373", borderRadius: "8px", padding: {xs : '10px 10px', lg : "20px 30px"} }}>
                <Stack direction={{xs : 'row', lg:'row'}} justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" gap={{xs : '30px', lg: '20px'}}>
                        <ChecklistFormIcon />
                        <Box>
                            <Typography variant="h7_1">Checklist</Typography><br />
                            <Typography variant="h9_5">Furniture & Equipment checklist</Typography>
                            
                            <Stack mt={1} direction="row" alignItems="center" justifyContent="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid red", backgroundColor: "#FFB8B8", borderRadius: "30px", padding: "10px", color: "#C38236" }}>
                                <Typography sx={{ fontWeight: 700, color : 'red' }} variant="h9_5">Resubmit</Typography>
                                {/* <SandClockIcon style={{ width: "10px", height: "13px" }} /> */}
                            </Stack>

                            <Typography sx={{color : 'red', mt : 1}}>{appliedData?.comments}</Typography>

                            {/* <Stack mt={1} direction="row" justifyContent="center" alignItems="center" gap="8px" sx={{ width: "100px", height: "30px", border: "1px solid #52AD33", backgroundColor: "#eef7eb", borderRadius: "30px", padding: "10px", color: "#52AD33" }}>
                                <Typography sx={{ fontWeight: 700 }} variant="h9_5">Done</Typography>
                                <ApprovedIcon />
                            </Stack> */}
                        </Box>
                    </Stack>
                    <Button onClick={() => setOpen(true)} variant='contained' sx={{ fontSize: "16px", fontWeight: 700 }}>Selected Products</Button>
                </Stack>
            </Stack>
            <Stack mt={3} direction="column">
                <Stack mb={1} direction="row" alignItems="center" justifyContent="start" gap="100px">
                    <Typography variant="h7_1">Terms & Conditions</Typography>
                </Stack>
                <Divider />
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', mt: 2, ml: 4 }} variant="h7_2">No wall pasting of any material is allowed in the room and toilet of the hostel. The cost of repainting of the damaged wall will be borne by the student. </Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2"> Dining in room is strictly prohibited, avoid using high voltage equipment such as kettle, iron, rice-cooker etc. Violator will be fined $50 each time. For dining, please use the multi-functional hall on first floor. Please keep the room clean &tidy.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">According to Singapore regulation, smoking is prohibited within the hostel premises. Violator will be fined $300 each time.</Typography>
                <Typography sx={{ listStyleType: 'disc', display: 'list-item', ml: 4 }} variant="h7_2">All furniture & equipment is in good working condition. In case of damage due to improper use, the original price listed in the check-list will be charged to the tenant </Typography>
            </Stack>

            <Box>
      <Typography variant="subtitle1" sx={{fontWeight : 700}} mt={4} mb={1}>
        Upload Signature
      </Typography>

      {/* {!signature ? (
        <Button
          variant="outlined"
          component="label"
          sx={{
            height: 120,
            width: 300,
            borderStyle: "dashed",
          }}
        >
          Click to Upload
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </Button>
      ) : ( */}
        <Box
          sx={{
            position: "relative",
            width: 300,
            height: 120,
            border: "1px solid #ddd",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <img
            src={`${process.env.REACT_APP_FILE_PATH}${appliedData?.signature?.filename}`}
            alt="Signature Preview"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />

          {/* <IconButton
            size="small"
            onClick={handleRemove}
            sx={{
              position: "absolute",
              top: 5,
              right: 5,
              backgroundColor: "white",
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton> */}
        </Box>
      {/* )} */}

    </Box>

            <Stack mt={2} gap="10px" direction="row" alignItems="center" justifyContent="start" >
                <Checkbox
    checked={isAgree}
    onChange={handleAgreeChange}
  />
                <Typography variant='h9_1' color="text_blue">I agree all the provided Information are correct</Typography>
            </Stack>
            <Stack my={3} direction="row" alignItems="center" justifyContent="start">
                <Button sx={{
    "&.Mui-disabled": {
      backgroundColor: "#E0E0E0",
      color: "#9E9E9E",
      cursor: "not-allowed",
    },
  }} disabled={!isAgree} onClick={() => handleReSubmit()} variant="standard">Resubmit</Button>
            </Stack>
        </Box>
         )}

         <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style}>
          <Typography variant="h4" sx={{fontWeight : 700}}>
            Furniture & Equipment checklist
          </Typography>
          <Typography mb={2} sx={{color : '#434343'}}>
            Select  yes or no for the mentioned items
          </Typography>

          <TableContainer component={Paper} sx={{height : 'auto', borderColor : '#737373'}}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{...tableHeader}}>No</TableCell>
                  <TableCell sx={{...tableHeader}}>Item</TableCell>
                  <TableCell sx={{...tableHeader}}>Price</TableCell>
                  <TableCell align="center" sx={{...tableHeader}}>Yes</TableCell>
                  {/* <TableCell align="center" sx={{...tableHeader}}>No</TableCell> */}
                </TableRow>
              </TableHead>

              <TableBody>
                {checkListProducts.map((product, index) => (
                  <TableRow key={product.id}>
                    <TableCell sx={{...tableText}}>{index + 1}</TableCell>
                    <TableCell sx={{...tableText}}>{product.item?.[language]}</TableCell>
                    <TableCell sx={{...tableText}}>S$ {product.price}</TableCell>

                    <TableCell align="center">
                      <Checkbox
                        disabled={!canSelectFields}
                        checked={selected[product._id] === "yes"}
                        onChange={() =>
                          handleCheckboxChange(product._id, "yes")
                        }
                        sx={{
    color: "#52AD33", // unchecked color
    "& .MuiSvgIcon-root": {
      fontSize: 24,
    },
    "&.Mui-checked": {
      color: "#52AD33", // checked color
    },
  }}
                      />
                    </TableCell>

                    {/* <TableCell align="center">
                      <Checkbox
                        disabled={!canSelectFields}
                        checked={selected[product._id] === "no"}
                        onChange={() =>
                          handleCheckboxChange(product._id, "no")
                        }
                        sx={{
    color: "#C81919", // unchecked color
    "& .MuiSvgIcon-root": {
      fontSize: 24,
    },
    "&.Mui-checked": {
      color: "#C81919", // checked color
    },
  }}
                      />
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            {canSelectFields && (
        <Button sx={{height : '40px'}} variant="outlined" onClick={() => {
                        setSelected({})
                        }}>
                      Clear
                    </Button>
            )}
            
            <Button sx={{height : '40px'}} variant="outlined" onClick={() => {
                setOpen(false)
                }}>
              Close
            </Button>
            {canSelectFields && (
              <Button
              variant="contained"
              sx={{height : '40px'}}
              onClick={() => {
                setOpen(false);
              }}
            >
              Done
            </Button>
            )}
            
          </Box>
        </Box>
      </Modal>
        </>
    )
}
